import { render, staticRenderFns } from "./ComSettleComment.vue?vue&type=template&id=371933e5&scoped=true"
import script from "./ComSettleComment.vue?vue&type=script&lang=js"
export * from "./ComSettleComment.vue?vue&type=script&lang=js"
import style0 from "./ComSettleComment.vue?vue&type=style&index=0&id=371933e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371933e5",
  null
  
)

export default component.exports